export function addOrEditById<I extends { id: string }>(items: I[], newItem: I) {
    return items.find(item => item.id === newItem.id) ?
        items.map(item => item.id === newItem.id ? newItem : item) :
        [...items, newItem];
}

export function removeById<I extends { id: string }>(items: I[], oldItem: I) {
    return items.filter(item => item.id !== oldItem.id);
}
